import "./AboutNTC.css";

export default function AboutNTC() {
  return (
    <section id="about-ntc" className="about-ntc-section">
      <h2 className="section-title">About NTC-2026</h2>

      <div className="about-container">
        <p className="about-text">
          Join us at <strong>Rangamati Science and Technology University (RMSTU)</strong> 
          on <strong>January 16 & 17, 2026</strong> for an exciting and vibrant event,
          the <strong>RMSTU National Tourism Conference 2026</strong> on the theme of
          <em> “Tourism Tomorrow: Nature's Next Fleck to Explore”.</em>
          <br /><br />
          In collaboration with the <strong>Bangladesh Tourism Board (BTB)</strong>, we are proud to 
          host this event that will bring together academics, tourism professionals, 
          researchers, policymakers, entrepreneurs, and students from all over the 
          country to explore the future of tourism in Bangladesh.
          <br /><br />
          Participants are invited to submit abstracts by <strong>January 02, 2026</strong> focusing 
          on key areas such as tourism & hospitality, tourism marketing, tourism 
          management, mountain tourism, biodiversity in tourism, sustainable 
          tourism, tourism informatics, application of AI in tourism, green financing 
          in tourism, blue economy in tourism, alternative forms of tourism, women 
          empowerment in tourism, indigenous tourism, eco-tourism, halal tourism, 
          culinary tourism, cultural tourism, regenerative tourism, and destination 
          management.
          <br /><br />
          Accepted abstracts will be featured in oral presentations, poster sessions, 
          and interactive discussions. Don’t miss this opportunity to engage with 
          leading experts, share your research, and contribute to building a more 
          inclusive, resilient, and sustainable tourism sector.
          <br /><br />
          We look forward to your participation in this landmark event.
        </p>
      </div>
    </section>
  );
}
